export default "__VITE_ASSET__fd2be406__"